import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";

function EditarEstadoCita() {

    const search = useLocation().search;

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const id = new URLSearchParams(search).get('id');

    const [nombre, setNombre] = useState('');
    const [color, setColor] = useState('');
    const [ocultar, setOcultar] = useState('0');

    let history = useHistory();
    let userdata = [];

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/estado-cita', config2)
            .then(response => {
                setNombre(response.data[0].nombre);
                setColor(response.data[0].color);
                setOcultar(response.data[0].ocultar_agenda == 1 ? '1' : '0');
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    function handleOcultar() {
        setOcultar(prev => String(prev) === '1' ? '0' : '1');
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const data = {
            uid: userdata.user_id,
            id: id,
            color: color,
            ocultar_agenda: ocultar
        };

        const config = {
            headers: { Authorization: 'Bearer ' + userdata.access_token }
        };

        axios.put('/estado-cita', data, config)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'El Estado "' + nombre + '" Ha Sido Modificado');
                    history.push('/estados-cita');
                }
            )
            .catch(
                err => {
                    setLoading(false);
                    console.log(err);
                }
            )
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-agenda">Parámetros de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/estados-cita">Estados De Las Citas</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar Estado</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Estado: {nombre}</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="card">
                                        <div className="card-body">
                                            <form id="role-form" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="nombre">Nombre del Estado</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="nombre"
                                                                value={nombre}
                                                                disabled
                                                            />
                                                            <small className="form-text text-muted">El nombre del estado no se puede modificar</small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label htmlFor="color">Color</label>
                                                            <input
                                                                type="color"
                                                                name="color"
                                                                className="form-control"
                                                                id="color"
                                                                value={color}
                                                                onChange={(e) => setColor(e.target.value)}
                                                                disabled={loading}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="row" style={{marginBottom: '20px'}}>
                                                            <div className="col-md-4">
                                                                <div className="custom-control custom-switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="custom-control-input"
                                                                        id="ocultar"
                                                                        checked={ocultar === '1'}
                                                                        onChange={() => handleOcultar()}
                                                                        disabled={loading}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor="ocultar" style={{whiteSpace: 'nowrap'}}>
                                                                        Ocultar en Agenda
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="d-flex gap-2">
                                                            <Link to="/estados-cita" className="btn btn-secondary mr-2">
                                                                Cancelar
                                                            </Link>
                                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                                Guardar Cambios
                                                                {loading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}
export default EditarEstadoCita;
